<script setup lang="ts">
withDefaults(
  defineProps<{
    /** What text should be displayed?<br/>(Can also be provided via the slot.) */
    text?: string
    /** How large should the text be? */
    size?: keyof typeof sizeMapping
    /** What HTML tag should be used to render the text? */
    tag?: string
  }>(),
  {
    tag: 'p',
    size: 'default'
  }
)

const sizeMapping = {
  default: 'text-brow',
  sm: 'text-brow-sm',
  lg: 'text-brow-lg'
}
</script>

<template>
  <component
    :is="tag"
    :class="sizeMapping[size]"
    class="font-sans uppercase font-bold"
  >
    {{ text }}
    <slot v-if="!text" />
  </component>
</template>
